import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsDashboardsRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-dashboards',
	path: '/jira/servicedesk/assets/dashboards',
	exact: true,
};
